export const color = '#ff6600';